export const defaultSeatPickerState = {
    validationErrorMessages: []
};
//# sourceMappingURL=state.js.map